import { useQuery } from "react-query";
import { getDVRTypeList } from "../../../../../actions/Utilities/DVRType";

export default function useGetDVRTypeList() {
  return useQuery("GetDVRType", getDVRTypeList, {
    refetchOnWindowFocus: false,
  });
}
